import data from "../data/dotNet.json";

const ssrsQuiz = data.ssrs;
const ssisQuiz = data.ssis;
const webApiQuiz = data.webapi;
const linqQuiz = data.linq;
const sharePointQuiz = data.sharepoint;
const fsharpQuiz = data.fsharp;
const vbDotNetQuiz = data.vbdotnet;
const csharpQuiz = data.csharp;
const dotnetQuiz = data.dotnet;
const aspdotnetQuiz = data["asp-dotnet"];
const adodotnetQuiz = data["ado-dotnet"];
const wpfQuiz = data.wpf;

export {ssrsQuiz, ssisQuiz, webApiQuiz, linqQuiz, sharePointQuiz, fsharpQuiz, vbDotNetQuiz, csharpQuiz,
    dotnetQuiz, aspdotnetQuiz, adodotnetQuiz, wpfQuiz
};
